import L from "leaflet";

const StartFinishLabelIcon = (label: string) => {
  return L.divIcon({
    className: "custom-label",
    html: `
        <div class="relative">
          <span class="absolute -top-16 -translate-x-1/2 whitespace-nowrap 
          px-2 py-1 rounded text-xs shadow-md tracking-wider
          ${label === "Fim" ? "bg-red-500 text-white" : "bg-green-500 text-white"}
          ">
            ${label}
          </span>
        </div>
      `,
    iconSize: [40, 40],
    iconAnchor: [0, 0],
  });
};

export default StartFinishLabelIcon;
